/**
 * @file newCollegeStudentEnrollment.js
 * @author Jake Stark
 * @desc PostGradIndicators report plugin

*/

/**
 * @module newCollegeStudentEnrollment 
 * @desc PostGradIndicators report plugin
 */

define('plugins/newCollegeStudentEnrollment',["underscore", "models", "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/newCollegeStudentEnrollment_programOfStudy_table.html!strip", "text!plugins/templates/newCollegeStudentEnrollment_topTenMajors_table.html!strip", "text!plugins/templates/newCollegeStudentEnrollment_timeSinceHsGrad_table.html!strip", "text!plugins/templates/newCollegeStudentEnrollment_diplomaType_table.html!strip", "text!plugins/templates/newCollegeStudentEnrollment_creditsTakenInFirstTerm_table.html!strip", "text!plugins/templates/newCollegeStudentEnrollment_transferCredits_table.html!strip", "cardboard/pluginPieces"
    ],
    function (_, SLEDSModels, CardboardModels, CardboardCollections, Util,
        programOfStudyTemplate, topTenMajorsTemplate, timeSinceHsGradTemplate, diplomaTypeTemplate, creditsTakenInFirstTermTemplate, transferCreditsTemplate, PluginPieces) {

        console.log("MODULE: newCollegeStudentEnrollment");

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                dynamicTextDomain: "collegeEnrollment",
                orgDetailPane: false,
                noMapSearch: true,
                forcedSummaryFilters: ["newCollegeStudentEnrollmentCOHORTID"],
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "Awards Sought",
                    explanationText: 'This report shows the number and percent of new entering students by the academic award they are working toward. "Unknown" means the college did not report the award type to the Minnesota Office of Higher Education.',
                    openByDefault: true,
                    views: [{
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            dataSetPath: "programOfStudy",
                            //dataPath: "dataSets.raceAndEthnicity.data", 
                            // all paths in the
                            // chartable series are
                            // relative to this blob

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",

                            // since in this case there's only one dimension, due to
                            // there being only one series to plot, it looks like
                            // this:
                            //	 +---------+
                            //	 | X X X X |
                            //	 +---------+
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,

                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "award",
                                longDisplayNamePath: "award",
                            }],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: programOfStudyTemplate,
                            dataSourceName: "data"
                        }
                    ]
                },
                {
                    title: "Top Ten Majors",
                    explanationText: "This report shows the number of new entering students by major or study upon entry. Unknown award means the college did not report the award type to the Minnesota Office of Higher Education. Unknown major means the student did not declare a major.",

                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: topTenMajorsTemplate,
                        dataSourceName: "data",
                        errorConditions: [{
                            valuePath: "data.data.topTenMajors.data[0]",
                            is: undefined,
                            error: {
                                type: "NoData",
                                message: "Sorry, we don't have any data for your selected College and Year."
                            }
                        }]

                    }]
                },
                {
                    title: "Time Since High School Graduation",
                    explanationText: 'This report shows the number and percent of new entering students by the year of high school graduation. "0 Years" means the student entered college within the same academic year as high school graduation (e.g. the student graduated from high school in December and enrolled in college in January). "Unknown Years" means the student did not complete high school or did not report their year of high school graduation to the college.',
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "timeSinceHighSchoolGraduation.slices",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            //  convertDataHashToArray: true,
                            dataDimensions: 2,
                            //xAxisLabelPath: "organizations.orgName",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                            // tooltipTemplate: "REPLACE",

                            // SERIES
                            series: [{
                                    seriesDisplayNamePath: "label",
                                    dataPath: "organizations",
                                    displayNamePath: "orgName",
                                    valuePath: "percent",
                                },
                               
                            ],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: timeSinceHsGradTemplate,
                            dataSourceName: "data",
                            //      //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                /*
                {
                    title: "High School Diploma Type",
                    explanationText: "This report shows new entering students by high school diploma awarded.",
                    openByDefault: false,
                    views: [
                        {
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "diplomaType.data",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsAcrossRows",
                            dataDimensions: 2,
                            // convertDataHashToArray: true,

                            // DISPLAY
                            unitString: "",
                            showLegend: false,
                            colorByPoint: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [
                                {
                                    //  dataPath: "chartMetrics",
                                    valuePath: "percent",
                                    //     seriesDisplayNamePath: "award",
                                    displayNamePath: "name",

                                }
                            ],
                        },
                        {
                            type: "template",
                            template: diplomaTypeTemplate,
                            dataSourceName: "data"
                        }
                    ]
                },*/
                {
                    title: "Credits Taken in First Term",
                    explanationText: "This report shows the number and percent of new entering students by the number of credits taken in their first term. This only includes students in credit-based programs. Full-time enrollment is defined as 12 or more credits for federal reporting purposes and 15 or more credits for state reporting purposes. To complete a 60-credit associate degree in 2 years or 120-credit bachelor’s degree in 4 years, the student would complete 15 or more credits per term or 30 or more credits per academic year.",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "stackedColumn",
                            dataSourceName: "data",
                            dataPath: "creditsTakenInFirstTerm.slices",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            //  convertDataHashToArray: true,
                            dataDimensions: 2,
                            //xAxisLabelPath: "organizations.orgName",

                            // DISPLAY
                            unitString: "%",
                            showLegend: true,
                            // tooltipTemplate: "REPLACE",

                            // SERIES
                            series: [{
                                    seriesDisplayNamePath: "label",
                                    dataPath: "organizations",
                                    displayNamePath: "orgName",
                                    valuePath: "percent",

                                },
                                {
                                    seriesDisplayNamePath: "label",
                                    dataPath: "organizations",
                                    displayNamePath: "orgName",
                                    valuePath: "percent",

                                },
                                {
                                    seriesDisplayNamePath: "label",
                                    dataPath: "organizations",
                                    displayNamePath: "orgName",
                                    valuePath: "percent",

                                },
                                {
                                    seriesDisplayNamePath: "label",
                                    dataPath: "organizations",
                                    displayNamePath: "orgName",
                                    valuePath: "percent",

                                },
                                {
                                    seriesDisplayNamePath: "label",
                                    dataPath: "organizations",
                                    displayNamePath: "orgName",
                                    valuePath: "percent",

                                }
                            ],
                            errorConditions: [{
                                valuePath: "data",
                                is: null,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: creditsTakenInFirstTermTemplate,
                            dataSourceName: "data",
                            //     //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Transfer Credits at Entry",
                    explanationText: "This report shows the percent of new enrolling students entering with credits and the average number of credits accepted by the college in the student's first term of enrollment. This data is collected at the beginning of the fall term for most colleges. If no credits are shown, the college did not report transfer credits in the first term for new enrolling students to the Minnesota Office of Higher Education.",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "transferCreditsAtEntry.data",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsAcrossRows",
                            dataDimensions: 2,
                            //convertDataHashToArray: true,

                            // DISPLAY
                            unitString: "%",
                            showLegend: false,
                            colorByPoint: true,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                seriesDisplayName: "[0].organizations[0].orgName",
                                values: [{
                                        valuePath: "[0].freshmenValue",
                                        pointLabel: "Freshman"
                                    },
                                    {
                                        valuePath: "[0].transferValue",
                                        pointLabel: "Transfer"
                                    }
                                ]
                            }],
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Sorry, we don't have any data for your selected College and Year."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: transferCreditsTemplate,
                            dataSourceName: "data",
                            //   //errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "More Information",
                    visibleByDefault: true,
                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: "<p><a href='' data-role='button' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a></p><p>For more information on college enrollment data, please visit the  <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary'>Data Interpretation Guide</a> and the <a href='http://www.ohe.state.mn.us/mPg.cfm?pageID=740'  target='_blank'>Office of Higher Education's Student Enrollment Data</a>.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031884&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all colleges or systems and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ps_orgid.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterData,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion_college.fex",
                    enabled: true
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_newcollegestudentenrollmentcohortid.fex",
                    enabled: true,
                    noViewParams: false,
                    modelType: CardboardModels.FilterData
                },
                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_newcollegeStudentEnrollmentButtons.fex",
                    enabled: true,
                    noViewParams: false,
                    isCat: true
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.DocumentModel,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_newcollegestudentenrollment.fex",
                    yearPath: "dataYear",
                    defaultParams: {
                        orgId: 999999000,
                        newCollegeStudentEnrollmentCOHORTID: 2015
                    },
                    paramMappings: {
                        PS_ORGID: "orgId",
                        newCollegeStudentEnrollmentCOHORTID: "dataYear",
                        orgName: null // skip this
                    },
                    /*         postProcessor: function (data) {
                                            // all we need to do is prettify all the org names!

                                            var blobs = [
                                            data.collegeEnrollment.slices,
                                            data.enrollmentOptions.slices,
                                            data.firstYearCredits.slices,
                                            data.developmentalCredits.slices,
                                            data.topTenInstitutions.institutions
                                        ];

                                            _(blobs).each(function (slices) {
                                                _(slices).each(function (slice) {
                                                    _(slice.organizations).each(function (org) {
                                                        org.orgName = Util.Data.prettifyName(org.orgName);
                                                    });
                                                });
                                            });
                                        },*/
                    enabled: true,
                    errorConditions: [{
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Sorry, we don't have any data for your selected College and Year."
                        }
                    }]
                }
            }
        };

        return exports;
    });
